import { render } from "./RequestedBookings.vue?vue&type=template&id=f97a9cac"
import script from "./RequestedBookings.vue?vue&type=script&lang=js"
export * from "./RequestedBookings.vue?vue&type=script&lang=js"
script.render = render

export default script